import { connect } from 'react-redux';
import { setWindowLocation } from 'js-utils/http';
import noop from 'lodash/noop';
import { connectUtils, actions } from '../event';
import { getEventStatusButtonType } from './organizer';
import { OrganizerHeader } from '../components';
import {
    getGuidedChecklistVariant,
    getIsMarketingToolsExperimentEnabled,
} from '../selectors';
import { EVENT_CANCELLED, EVENT_POSTPONED } from '../constants/header';

const {
    dispatchPublishEvent,
    dispatchUnpublishEvent,
    dispatchCancelEvent,
    dispatchDeleteEvent,
    dispatchCancelSchedulePublish,
    changeSalesStatus,
} = connectUtils;

const { clearEventStatusError, navigateAfterClick } = actions;

const getEventActionError = (state) => {
    let eventActionError;

    if (state.eventStatus && state.eventStatus.statusError) {
        eventActionError = state.eventStatus.statusError.error;
    }

    return eventActionError;
};

export const mapStateToProps = (state, eventData) => ({
    eventActionError: getEventActionError(state),
    eventStatusButtonType: getEventStatusButtonType(eventData),
    guidedChecklistVariant: getGuidedChecklistVariant(state),
    isManagePage: true,
    isMarketingToolsExperimentEnabled: getIsMarketingToolsExperimentEnabled(
        state,
    ),
    navigateToUrl: setWindowLocation,
});

const mapDispatchToProps = (dispatch, eventId) => ({
    onPublishClick: ({
        facebookEventId,
        guidedChecklistVariant,
        hasCoyotePaidPublish,
        hasCoyotePublish,
        hasPaidPublish,
        hasPublish,
        isMarketingToolsExperimentEnabled,
        isPaidEvent,
        isPoweredByFb,
    }) =>
        dispatchPublishEvent({
            dispatch,
            eventId,
            facebookEventId,
            guidedChecklistVariant,
            hasCoyotePaidPublish,
            hasCoyotePublish,
            hasPaidPublish,
            hasPublish,
            isMarketingToolsExperimentEnabled,
            isPaidEvent,
            isPoweredByFb,
        }),
    onUnpublishClick: () =>
        dispatchUnpublishEvent(dispatch, eventId).then(() =>
            setWindowLocation(`/myevent?eid=${eventId}`),
        ),

    onCancelClick: (shouldRedirectToAttendeeEmail) =>
        dispatchCancelEvent(dispatch, eventId).then(() =>
            dispatch(
                navigateAfterClick(
                    eventId,
                    EVENT_CANCELLED,
                    shouldRedirectToAttendeeEmail,
                ),
            ),
        ),
    onPostponeClick: (shouldRedirectToAttendeeEmail) =>
        dispatch(
            changeSalesStatus(eventId, {
                statusCode: 'event_postponed',
                customMessage: '',
            }),
        )
            //TODO: Redirect with a success message
            .then(() =>
                dispatch(
                    navigateAfterClick(
                        eventId,
                        EVENT_POSTPONED,
                        shouldRedirectToAttendeeEmail,
                    ),
                ),
            )
            .catch(noop),
    onDeleteClick: () => dispatchDeleteEvent(dispatch, eventId),
    onClearError: () => dispatch(clearEventStatusError()),

    onCancelSchedulePublishClick: () =>
        dispatchCancelSchedulePublish(dispatch, eventId),
});

const getConnectedOrganizerHeader = (eventId, eventData) =>
    connect(
        (state) => mapStateToProps(state, eventData),
        (dispatch) => mapDispatchToProps(dispatch, eventId),
    )(OrganizerHeader);

export default getConnectedOrganizerHeader;
